<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-31 13:43:16
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2021-03-03 11:15:49
 * @Description: 空白字段，作为占位符号出现，在wg-form中使用v-slot调用
 -->

<template>
  <div widget-type="blank"
    class="blank">
    <slot :name="widget.model"
      :value="value"
      :data-model="fieldName"
      :wg="widget.model"
      :options='widget.options'></slot>
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
};
</script>
